import React from 'react'
import {ViewPropTypes, View} from 'react-native'
import PropTypes from 'prop-types'

import styles from './HorizontalLine.Styles'

function HorizontalLine(props) {
  const {style, ...rest} = props
  return <View style={[styles.horizontalLine, style]} {...rest}/>
}

HorizontalLine.propTypes = {
  style: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style)
  ])
}

export default HorizontalLine
